module.exports = __webpack_public_path__ + "static/media/image-alt-slash.15b735ba.svg";